<template>
  <div class="wg-text sensitive" data-demo-blur v-html="html" />
</template>

<script>
import { marked } from 'marked';
import DOMPurify from 'dompurify';

export default {
  name: 'TextWidget',
  props: {
    inputs: { type: Object, default: () => ({}) },
    config: { type: Object, default: () => ({}) },
    scope: { type: Object, default: () => ({}) },
    width: { type: Number, default: 0 },
    height: { type: Number, default: 0 },
  },
  computed: {
    html() {
      const source = String(this.config.markdown || this.config.text || '');
      return DOMPurify.sanitize(marked.parse(source, { breaks: true }));
    },
  },
};
</script>

<style scoped>
.wg-text { height: 100%; overflow: auto; padding: 12px 16px; font-size: 14px; line-height: 1.5; color: #3C4257; }
.wg-text :deep(h1), .wg-text :deep(h2), .wg-text :deep(h3) { color: #1A1A2E; margin: 0 0 8px; line-height: 1.25; }
.wg-text :deep(h1) { font-size: 20px; }
.wg-text :deep(h2) { font-size: 16px; }
.wg-text :deep(h3) { font-size: 14px; }
.wg-text :deep(p) { margin: 0 0 8px; }
.wg-text :deep(ul), .wg-text :deep(ol) { margin: 0 0 8px 18px; }
.wg-text :deep(strong) { color: #1A1A2E; }
</style>
